module.exports = __webpack_public_path__ + "img/nfts.41b8a45d.png";